module.exports = __webpack_public_path__ + "static/media/madhumita-moi.3adb289a.jpeg";